import { SWReactIcons } from "@similarweb/icons";

export default SWReactIcons;
